// Constants.js
export const CON_STATUS_ZERO = "0";
export const CON_STATUS_NONE = "";

export const CON_VALUE_ZERO = 0;
export const CON_EMPTY_VALUE = "";
export const CON_VALUE_ZERO_ST = "0.00";

export const CON_STATUS_ACTIVE = "A";

export const CON_STATUS_RESTAURANTS = "P";
export const CON_STATUS_KITCHEN = "K";
export const CON_STATUS_PENDING = "P";
export const CON_STATUS_NEW = "N";
export const CON_STATUS_YES = "Y";
export const CON_STATUS_NO = "N";
export const CON_STATUS_RETURN = "R";
export const CON_STATUS_REJECTED = "R";
export const CON_STATUS_RECEIVED = "R";
export const CON_STATUS_DELETED = "D";
export const CON_STATUS_USER= "U";
export const CON_STATUS_ALL = "X";

export const CON_MENU_TYPE_CODE = "F";

export const CON_IS_CASHIER_YES = "Y";
export const CON_IS_CASHIER_NO = "N";
export const CON_IS_CREDIT_NO = "N";

export const CON_CAT_TYPE_RESTAURANT = "R";
export const CON_CAT_TYPE_POS = "P";

export const CON_MODULECODE = "7";

// Cashier page
export const CON_ADDON_CODE = "0";
export const CON_IS_ADDON = "N";
export const CON_IS_ADDON_YES = "Y";
export const CON_CODENRATE = "0";
export const CON_TAX_PAGE_CODE = "PO";
export const CON_TAX_CODE = "1017";
export const CON_TAX_RATE = "10";
export const CON_TAX_AMOUNT = "60";

export const CON_DELIVERY_STS = "Y";
export const CON_GUEST_REF_CODE = "GREF001";
export const CON_IP_ADDRESS = "192.168.1.1";

export const CON_DEF_WAITING_TIME = 2000;

export const CON_MENUICON_WIDTH = 128;
export const CON_MENUICON_HEIGHT = 128;

export const CON_MAX_FILESIZE_ITEMIMG = 1048576;
export const CON_MAX_FILESIZE_PROMO = 1048576;

export const CON_ORDERTYPE_ONSHOP = "8";
export const CON_MODULEKEY = "PWj6Rgedul1KcmrgHZ3TlLuazmyF9FE0";

export const CON_YES = "Yes";
export const CON_NO = "No";

export const CON_REGEX_LNS_150 = /^[a-zA-Z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{0,150}$/;
export const CON_REGEX_LNS_20 = /^[a-zA-Z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{0,20}$/;

export const CON_ORDER_STATUS_LIST = [
    { ORDERSTATUSCODE: CON_STATUS_ALL, ORDERSTATUSNAME: "All" },
    { ORDERSTATUSCODE: CON_STATUS_ACTIVE, ORDERSTATUSNAME: "Paid" },
    { ORDERSTATUSCODE: CON_STATUS_PENDING, ORDERSTATUSNAME: "Orders" },
    // { ORDERSTATUSCODE: CON_STATUS_RETURN, ORDERSTATUSNAME: "Returned Orders" },
  ];

export const CON_ORDER_RETURN = "Return";
export const CON_ORDER_REFUND = "Refund";
export const CON_ORDER_EXCHANGE = "Exchange";
export const CON_ORDER_CANCEL = "Cancel";
export const CON_ORDER_VOID = "Void";

export const CON_ORTC_RETURN = 1;
export const CON_ORTC_REFUND = 2;
export const CON_ORTC_EXCHANGE = 3;
export const CON_ORTC_VOID = 4;

/** Credit / exchange note validity: days from return date until expiry */
export const CON_NOTE_EXPIRY_DAYS = 30;

/** REFUNDSTS codes for credit / exchange notes */
export const CON_NOTE_REFUND_CLAIMED = "R";
export const CON_NOTE_REFUND_PENDING = "P";

// Return type short codes used in return number generation
export const CON_ORTC_SHORT_RETURN   = "CN";
export const CON_ORTC_SHORT_REFUND   = "RF";
export const CON_ORTC_SHORT_EXCHANGE = "EX";
export const CON_ORTC_SHORT_VOID     = "VD";

/**
 * Returns the short code for a given return type code.
 * @param {number} returnTypeCode - CON_ORTC_RETURN | CON_ORTC_REFUND | CON_ORTC_EXCHANGE | CON_ORTC_VOID
 * @returns {string} e.g. "CN", "RF", "EX", "VD"
 */
export const getReturnTypeShortCode = (returnTypeCode) => {
  switch (returnTypeCode) {
    case CON_ORTC_RETURN:   return CON_ORTC_SHORT_RETURN;
    case CON_ORTC_REFUND:   return CON_ORTC_SHORT_REFUND;
    case CON_ORTC_EXCHANGE: return CON_ORTC_SHORT_EXCHANGE;
    case CON_ORTC_VOID:     return CON_ORTC_SHORT_VOID;
    default:                return CON_ORTC_SHORT_RETURN;
  }
};

const RETURN_ACTIVITY_LABELS = {
  [CON_ORTC_RETURN]: {
    pageTitle: "Return Details",
    sectionInfo: "Return Information",
    sectionItems: "Returned Items",
    refNo: "Return No",
    cnExNo: "CN/EX/VD No",
    date: "Return Date",
    amount: "Return Amount",
    rate: "Return Rate",
  },
  [CON_ORTC_REFUND]: {
    pageTitle: "Refund Details",
    sectionInfo: "Refund Information",
    sectionItems: "Refunded Items",
    refNo: "Refund No",
    cnExNo: "CN/EX/VD No",
    date: "Refund Date",
    amount: "Refund Amount",
    rate: "Refund Rate",
  },
  [CON_ORTC_EXCHANGE]: {
    pageTitle: "Exchange Details",
    sectionInfo: "Exchange Information",
    sectionItems: "Exchanged Items",
    refNo: "Exchange No",
    cnExNo: "CN/EX/VD No",
    date: "Exchange Date",
    amount: "Exchange Amount",
    rate: "Exchange Rate",
  },
  [CON_ORTC_VOID]: {
    pageTitle: "Void Details",
    sectionInfo: "Void Information",
    sectionItems: "Voided Items",
    refNo: "Void No",
    cnExNo: "CN/EX/VD No",
    date: "Void Date",
    amount: "Void Amount",
    rate: "Void Rate",
  },
};

/**
 * UI labels for return activity list/details pages by return type code.
 * @param {number|string} returnTypeCode - CON_ORTC_RETURN | CON_ORTC_REFUND | CON_ORTC_EXCHANGE | CON_ORTC_VOID
 */
export const getReturnActivityLabels = (returnTypeCode) => {
  const code = Number(returnTypeCode);
  return RETURN_ACTIVITY_LABELS[code] || RETURN_ACTIVITY_LABELS[CON_ORTC_RETURN];
};

/**
 * Display name for return activity type chips and history rows.
 * @param {number|string} returnTypeCode
 */
export const getReturnTypeDisplayLabel = (returnTypeCode) => {
  const code = Number(returnTypeCode);
  switch (code) {
    case CON_ORTC_REFUND:   return CON_ORDER_REFUND;
    case CON_ORTC_EXCHANGE: return CON_ORDER_EXCHANGE;
    case CON_ORTC_VOID:     return CON_ORDER_VOID;
    case CON_ORTC_RETURN:
    default:                return CON_ORDER_RETURN;
  }
};

/** Cashier summary claimed-amount row when a credit/exchange note is applied. */
export const getCashierCeNoteClaimedLabel = (returnTypeCode) => {
  const code = Number(returnTypeCode);
  if (code === CON_ORTC_EXCHANGE) return CON_ORDER_EXCHANGE;
  if (code === CON_ORTC_RETURN) return "Credit Note";
  return "Credit Note";
};

/** Bill payment line label for CENOTEAMOUNT. */
export const getBillCeNotePaymentLabel = (returnTypeCode) => {
  const code = Number(returnTypeCode);
  if (code === CON_ORTC_EXCHANGE) return CON_ORDER_EXCHANGE;
  if (code === CON_ORTC_RETURN) return CON_ORDER_RETURN;
  return "Credit Note";
};

export const VALID_RETURN_TYPE_CODES = [
  CON_ORTC_RETURN,
  CON_ORTC_REFUND,
  CON_ORTC_EXCHANGE,
  CON_ORTC_VOID,
];

export const isValidReturnTypeCode = (code) =>
  VALID_RETURN_TYPE_CODES.includes(Number(code));

/** Read RETURNTYPECODE from an API history line. */
export const parseReturnTypeCode = (line) =>
  Number(line?.RETURNTYPECODE ?? line?.returntypecode);

/**
 * Resolve transaction type label for order-return previous activity rows.
 * RETURNTYPECODE (1–4) from the backend is authoritative when present.
 */
export const getReturnActivityLabelFromLine = (line) => {
  const code = parseReturnTypeCode(line);
  if (isValidReturnTypeCode(code)) {
    return getReturnTypeDisplayLabel(code);
  }

  const desc = String(line?.RETURNTYPEDESCRIPTION || "").trim();
  const descLower = desc.toLowerCase();
  if (descLower.includes("void")) return CON_ORDER_VOID;
  if (descLower.includes("exchange")) return CON_ORDER_EXCHANGE;
  if (descLower.includes("refund")) return CON_ORDER_REFUND;
  if (descLower.includes("return")) return CON_ORDER_RETURN;
  if (desc) return desc;

  if (line?.ISREFUND === CON_STATUS_YES) return CON_ORDER_REFUND;
  return CON_ORDER_RETURN;
};

/**
 * Generates a return number in the format: SHORTCODE-USERREFCODE-RESTCODE-DDMMYYHHMMSS
 * e.g. "EX-002-150-260518111100"
 * @param {number} returnTypeCode
 * @param {string} userRefCode
 * @param {string} restCode
 * @returns {string}
 */
export const generateReturnNo = (returnTypeCode, userRefCode, restCode) => {
  const shortCode = getReturnTypeShortCode(returnTypeCode);
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const day    = pad(now.getDate());
  const month  = pad(now.getMonth() + 1);
  const year   = String(now.getFullYear()).slice(-2);
  const hours  = pad(now.getHours());
  const mins   = pad(now.getMinutes());
  const secs   = pad(now.getSeconds());
  const datetime = `${day}${month}${year}${hours}${mins}${secs}`;
  return `${shortCode}-${userRefCode}-${restCode}-${datetime}`;
};
  

// export const GUEST_PAGE_URL =
//   "Guest?compcode=Q1AyMjAwMDAxMDc=&loccode=TVJUTUNMQzAwNTk=&restcode=NA==";
// export const GUEST_CHECKOUT_URL =
//   "GuestCheckout?compcode=Q1AyMjAwMDAxMDc=&loccode=TVJUTUNMQzAwNTk=&restcode=NA==";
